import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import Lottie from "lottie-web"
import VidioAnimation from '../../lottieLoader.json'
import Component from '@javascripts/components/component'

export default class LottieLoader extends Component {
  constructor(player, options){
    super(player, options)

    this.updateText(options.text)
  }

  createEl() {
    const el = VideoJsAdapter.global().createEl('div', {
      id: 'lottie-container',
      className: 'vjs-hidden'
    })

    el.innerHTML = '<div id="lottie"></div><h1 class="text"></h1>'

    return el
  }

  setupLottie() {
    Lottie.loadAnimation({
      wrapper: this.$('#lottie'),
      animType: 'svg',
      loop: true,
      path: VidioAnimation
    })
  }

  updateText(text = 'Iklan sebentar lagi akan tayang') {
    this.$('.text').innerHTML = text
  }
}

VideoJsAdapter.registerComponent('LottieLoader', LottieLoader)
